<button
  type="button"
  [disabled]="disabled"
  [attr.aria-label]="'Добавяне/Премахване на обява от списъка с харесани.'"
  class="btn btn-light border"
  [ngClass]="!!userAdLikeId ? 'text-danger' : 'text-muted'"
  (click)="onToggleLike(); $event.stopPropagation()">
  <i class="fa-solid fa-heart" aria-hidden="true"></i>
</button>
